// Cycle-count-side predicate for the Sobrantes hand-off. The link builder, the deep-link parser,
// the resolve-payload summary and the skip vocabulary live with the screen they point at, in
// src/pages/FoundStock/foundStockLinks.js.
export const locationHasSurplus = location =>
  location?.status === 'resolved' && (location.reviewer_results || []).some(r => (r.counted_quantity ?? 0) > (r.system_quantity ?? 0))
